// extracted by mini-css-extract-plugin
export default {"caption":"a2G1W","themeWhite":"b2G1W","themeBlue":"c2G1W","sizeXs":"d2G1W","sizeS":"e2G1W","sizeM":"f2G1W","sizeL":"g2G1W","sizeXl":"h2G1W","sizeXxl":"i2G1W"};